import { PublicModulesRouteMap } from '@/new-router/public-modules'

const officialPage = () => import('@/views/Feedback/officialPage')
const platformPage = () => import('@/views/Feedback/platformPage')
const userResearch = () => import('@/views/Feedback/userResearch')

const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
  }
**/

export default [
  {
    path: '/feedback',
    name: 'feedback',
    component: Home,
    meta: {
      title: '反馈管理',
      icon: 'icon-rent',
      showSubiems: false,
      sort: 5,
      modules: 'feedback',
      permission: 'feedback:root',
    },
    children: [
      {
        path: 'officialPage',
        name: 'officialPage',
        component: officialPage,
        meta: {
          title: '官网反馈',
          sort: 1,
          active: ['officialPage'],
          permission: 'website:feedback:root',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.FeedbackManagement],
          nocache: true,
        },
      },
      {
        path: 'platformPage',
        name: 'platformPage',
        component: platformPage,
        meta: {
          title: '平台反馈',
          sort: 2,
          active: ['platformPage'],
          permission: 'platform:feedback:root',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.FeedbackManagement],
          nocache: true,
        },
      },
      {
        path: 'userResearch',
        name: 'userResearch',
        component: userResearch,
        meta: {
          title: '用户调研',
          sort: 3,
          active: ['userResearch'],
          permission: 'research:feedback:root',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.FeedbackManagement],
          nocache: true,
        },
      },
    ],
  },
]
